import { render } from "./PerjanjianKinerjaSatker.vue?vue&type=template&id=ade96d4e"
import script from "./PerjanjianKinerjaSatker.vue?vue&type=script&lang=js"
export * from "./PerjanjianKinerjaSatker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__